import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as JobbirdIcon } from './jobbird.svg';

export const Jobbird = IconHOC(JobbirdIcon);
